import { regex } from './common'
export default regex('legalRfc', /^[a-zA-Z0-9ñÑ&-]{12}$/)